/* eslint-disable max-len */
/* eslint-disable max-lines */
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Button, Card, Icon, Popup} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {createOrderScreens} from '../../constants/internalScreens';
import {customValuesOrders, generateNotifications, getErrorMessage, sumShipment} from '../utils';
import AddOrderModal from '../showOrder/addOrderModal';
import moment from 'moment';
import {noTimeZoneShortISODate, reverseShortDate} from '../../../common/constants/datesFormat';
import {handleExcelReport} from '../../../common/components/commercialTable/exportUtils/handleExport';
import {originsTableHeaderWithProps} from '../showOrder/showOrdersTable';

const Header = (props) => {
  const {screen} = props;

  const handleAddOrEditOrigin = () => {
    if (!props.activeOrigin) {
      props.activateOrigin({
        'country': '',
        'description': '',
        'arrival_time': '',
        'country_equivalence': '',
      });
    }

    if (props.activeOrigin) {
      props.fetchAddOrEditOrigin(props.activeOrigin);
      props.desactivateOrigin({});
    }
  };

  const handleGenerateOrder = () => {
    props.fetchGenerateOrder({'totalOrderArray': props.ordersProcessedData});
  };

  const handleEndGenerateOrder = () => {
    props.cleanCreateOrder();
  };

  const {originsAllData,
    originsAllDataFixed,
    ordersByShipment,
    ordersByShipmentMapped,
    shipmentHeader,
  } = props;
  const handleUpdateOrder = () => {
    const notifications = generateNotifications(originsAllData, originsAllDataFixed, ordersByShipment);
    props.fetchUpdateOrderData(
      props.headerValues.orderNumber,
      {'detailModified': notifications, 'headerValues': props.headerValues}
    );
  };

  const header = props?.originsAllData?.resultHeader;
  const validateOrderValues = header?.supplier && header?.model_year;
  const [sumCurrentShipment, setSumCurrentShipment] = useState(0);
  useEffect(() => {
    if (ordersByShipmentMapped && shipmentHeader?.shipment) {
      const value = sumShipment(ordersByShipmentMapped, shipmentHeader?.shipment).sum;
      setSumCurrentShipment(value);
    }
  }, [ordersByShipmentMapped, shipmentHeader]);
  
  return (
    <Card className='small-title-container'>
      <div className="title-bar center-vertical w-100">
        <div className="title center-vertical">
          <h2>
            Administración de pedidos {props.title && ` - ${props.title}`}
          </h2>
          {screen === createOrderScreens.main && (
            <div className="title-bar-actions">
              <Link to="parametros">
                <Button type="button" secondary className="toyota-secondary">
                  Editar parámetros
                </Button>
              </Link>
              <Link to="crear-pedido">
                <Button primary type="submit" className="toyota-primary">
                  Generar nuevo pedido
                </Button>
              </Link>
            </div>
          )}
          {screen === createOrderScreens.create && (
            <div className="title-bar-actions">
              {!props.createdOrder && (
                <Link to="/vehiculos/administracion-pedidos">
                  <Button type="button" basic className="toyota-secondary">
                    Cerrar
                  </Button>
                </Link>
              )}
              {props.ordersProcessedData && !props.createdOrder && (
                <Button
                  primary
                  type="submit"
                  className="toyota-primary"
                  onClick={handleGenerateOrder}
                  disabled={!props.isValidOrder}
                >
                  Generar pedido
                </Button>
              )}
              {props.createdOrder && (
                <Link to="/vehiculos/administracion-pedidos">
                  <Button
                    type="button"
                    primary
                    className="toyota-secondary"
                    onClick={handleEndGenerateOrder}
                  >
                    Finalizar
                  </Button>
                </Link>
              )}
            </div>
          )}
          {screen === createOrderScreens.show && (
            <div className="title-bar-actions">
              {props.isShipmentScreen ? (
                <span>
                  {!props.showShipmentHeader ? (
                    <Button
                      primary
                      onClick={() => {
                        props.setShowShipmentHeader(true);
                        props.setShowShipmentHeaderShip(
                          parseInt(props.ordersByShipment[0].nShips.value, 10) + 1
                        );
                        props.setUpdateShipmentHeader('ADD');
                        props.setCleanShipmentHeader();
                        props.setShipmentHeader(
                          'shipment',
                          parseInt(props.ordersByShipment[0].nShips.value, 10) + 1
                        );
                        props.setShipmentHeader(
                          'orderNumber',
                          props.ordersByShipment[0].order.value
                        );
                        props.setShipmentHeader(
                          'dateOfArrival',
                          moment(
                            props?.originsAllData?.resultHeader.arrivalDate,
                            noTimeZoneShortISODate
                          ).format(reverseShortDate)
                        );
                        props.setShipmentHeader(
                          'dateOfShipment',
                          moment(
                            props?.originsAllData?.resultHeader.shipmentDate,
                            noTimeZoneShortISODate
                          ).format(reverseShortDate)
                        );
                      }}
                    >
                      Añadir embarque
                    </Button>
                  ) :
                    (
                      <div>
                        
                        {props.updateShipmentHeader === 'UPDATE' &&

                          <Popup
                            trigger={
                              <span>
                                <Button
                                  loading={props.loading}
                                  disabled={
                                    (sumCurrentShipment === 0 && props.showShipmentHeaderShip < parseInt(props.ordersByShipment[0].nShips.value, 10)) ||
                                    !validateOrderValues}
                                  primary
                                  type="submit"
                                  className="toyota-primary"
                                  onClick={() => {
                                    props.fetchPostShipmentHeader({
                                      'shipmentItems': props.ordersByShipmentMapped,
                                      'shipmentHeader': shipmentHeader,
                                      'flag': 'update',
                                    });
                                    props.setUpdateShipmentHeader(false);
                                    props.setShowShipmentHeader(false);
                                  }}
                                >
                                  Actualizar embarque
                                </Button>
                              </span>
                            }
                            content={getErrorMessage(sumCurrentShipment, validateOrderValues)}
                            position='top center'
                            size='small'
                            style={{'marginBottom': '20px'}}
                            inverted
                            disabled={
                              !(sumCurrentShipment === 0 &&
                                props.showShipmentHeaderShip < parseInt(props.ordersByShipment[0].nShips.value, 10)
                              ) &&
                              validateOrderValues
                            }
                          />
                        }
                        { props.updateShipmentHeader === 'ADD' &&
                          <Popup
                            trigger={
                              <span>
                                <Button
                                  primary
                                  loading={props.loading}
                                  disabled={!sumCurrentShipment || !validateOrderValues}
                                  type="submit"
                                  className="toyota-primary"
                                  content={'Añadir embarque'}
                                  onClick={() => {
                                    props.fetchPostShipmentHeader({
                                      'shipmentItems': props.ordersByShipmentMapped,
                                      'shipmentHeader': shipmentHeader,
                                      'flag': 'add',
                                    });
                                    props.setUpdateShipmentHeader(false);
                                    props.setShowShipmentHeader(false);
                                  }}
                                />
                              </span>
                            }
                            content={getErrorMessage(sumCurrentShipment, validateOrderValues)}
                            position='top center'
                            size='small'
                            style={{'marginBottom': '20px'}}
                            inverted
                            disabled={sumCurrentShipment && validateOrderValues}
                          />
                        }
                      </div>
                    )
                  }
                </span>
              ) : (
                <>
                  <Button primary
                    disabled={!props.originsAllData || props.loading}
                    onClick={() => {
                      const excelRows = props.filteredData.map((row) => {
                        return row.original;
                      });
                      const columns = originsTableHeaderWithProps([], null, [], 0);
                      handleExcelReport(excelRows, columns, customValuesOrders, 'REPORTE-PEDIDOS');
                    }}
                    className="toyota-secondary"
                    icon
                    labelPosition='left'
                  >
                    <Icon name='file excel' fitted size='tiny' style={{'fontSize': '20px'}}/>
                    Exportar a Excel
                  </Button>
                  <AddOrderModal />
                </>
              )}
              <div class="vl"></div>
              {props.showShipmentHeader ?
                (
                  <Button
                    type="button"
                    basic
                    className="toyota-secondary"
                    onClick={() => {
                      props.setShowShipmentHeader(false);
                      props.setCleanShipmentHeader();
                      props.cleanShipmentTable();
                      props.setUpdateShipmentHeader(false);
                    }}
                  >
                        Cancelar
                  </Button>
                ) :
                (
                  <>
                    {!props.createdOrder && (
                      <Link to="/vehiculos/administracion-pedidos">
                        <Button type="button" basic className="toyota-secondary">
                          Cerrar
                        </Button>
                      </Link>
                    )}
                  </>
                )
              }
              
              {!props.showShipmentHeader && (<Button
                type="button"
                primary
                disabled={!props.headerValues.year_model}
                className="toyota-secondary"
                onClick={handleUpdateOrder}
                loading={props.loading}
              >
                Actualizar orden
              </Button>)}
            </div>
          )}
          {screen === createOrderScreens.parameters && (
            <div className="title-bar-actions">
              {props.activeOrigin ? (
                <Button
                  type="button"
                  basic
                  className="toyota-secondary"
                  onClick={() => props.desactivateOrigin()}
                >
                  Cerrar
                </Button>
              ) : (
                <Link to="/vehiculos/administracion-pedidos">
                  <Button
                    type="button"
                    basic
                    className="toyota-secondary"
                    onClick={() => props.desactivateOrigin()}
                  >
                    Cerrar
                  </Button>
                </Link>
              )}
              <Button
                type="submit"
                color="red"
                className="toyota-primary"
                onClick={() => handleAddOrEditOrigin()}
              >
                {props.activeOrigin ? 'Guardar' : 'Añadir orígen'}
              </Button>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.manageOrders.loading,
    'activeOrigin': state.manageOrders.activeOrigin,
    'createdOrder': state.manageOrders.createdOrder,
    'headerValues': state.manageOrders.headerValues,
    'isValidOrder': state.manageOrders.isValidOrder,
    'ordersProcessedData': state.manageOrders.ordersProcessedData,
    'originsAllData': state.manageOrders.originsAllData,
    'originsAllDataFixed': state.manageOrders.originsAllDataFixed,
    'ordersByShipment': state.manageOrders.ordersByShipment,
    'ordersByShipmentMapped': state.manageOrders.ordersByShipmentMapped,
    'shipmentHeader': state.manageOrders.shipmentHeader,
    'showShipmentHeader': state.manageOrders.showShipmentHeader,
    'updateShipmentHeader': state.manageOrders.updateShipmentHeader,
    'showShipmentHeaderShip': state.manageOrders.showShipmentHeaderShip,
  };
};
const {
  activateOrigin,
  cleanShipmentTable,
  desactivateOrigin,
  fetchAddOrEditOrigin,
  fetchGenerateOrder,
  fetchPostShipmentHeader,
  cleanCreateOrder,
  fetchUpdateOrderData,
  setShowShipmentHeader,
  setShowShipmentHeaderShip,
  setUpdateShipmentHeader,
  setCleanShipmentHeader,
  setShipmentHeader,
} = Actions;

export default connect(mapStateToProps, {
  activateOrigin,
  cleanShipmentTable,
  desactivateOrigin,
  fetchAddOrEditOrigin,
  fetchGenerateOrder,
  fetchPostShipmentHeader,
  cleanCreateOrder,
  fetchUpdateOrderData,
  setShowShipmentHeader,
  setShowShipmentHeaderShip,
  setUpdateShipmentHeader,
  setCleanShipmentHeader,
  setShipmentHeader,
})(Header);
